import type { PrincipalTeacherDto, UserDto } from "@/entities/user/models/dtos";
import { UserType as AUserType } from "@/entities/user/models/enums";

export interface PrincipalDto extends PrincipalTeacherDto {}
export const UserType = AUserType;

export interface AuthState {
    userDto: UserDto | null;
    userEmail: string;
    academyId: string;
    teacherId: string;
    userType: number;
}
